import { ANSWER_WORDS } from './answer-words';

export const GAME_START_DATE = new Date(2022, 1, 20); // Feb 20, 2022

const MS_PER_DAY = 1000 * 60 * 60 * 24;

// Number of whole days between the game epoch and the given date (local time)
export function getGameNumber(date = new Date()) {
    const start = new Date(GAME_START_DATE.getFullYear(), GAME_START_DATE.getMonth(), GAME_START_DATE.getDate());
    const current = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.max(0, Math.round((current - start) / MS_PER_DAY));
}

// Daily word: walks the shuffled answer list one word per day
export function getWord(date = new Date()) {
    return ANSWER_WORDS[getGameNumber(date) % ANSWER_WORDS.length];
}
